module.exports = __webpack_public_path__ + "static/media/logohelios.8552c1df.jpg";